import { render, staticRenderFns } from "./_FormGroup.vue?vue&type=template&id=24bcf7a4&scoped=true&"
import script from "./_FormGroup.vue?vue&type=script&lang=js&"
export * from "./_FormGroup.vue?vue&type=script&lang=js&"
import style0 from "./_FormGroup.vue?vue&type=style&index=0&id=24bcf7a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bcf7a4",
  null
  
)

export default component.exports